<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3 flex items-center">
          <li class="flex items-center gap-3">
            <router-link to="/setup/customer-feedback" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
            <h3>{{ $t("View Customer Feedback") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2">
                <li>
                  <h4 class="mb-2 font-semibold">
                    {{ $t("Ticket Overview") }}
                  </h4>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full">
              <tr>
                <td>
                  <b>{{ $t("setup.label.TicketId") }}</b>
                </td>
                <td>{{ $route.params.ticketId }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("Submitted By") }}</b>
                </td>
                <td>{{ $route.params.clientName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("Submitted On") }}</b>
                </td>
                <td>{{ getDate(feedbackDetailsCampaingn .submittedAt) }}</td>
              </tr>
            </table>
          </div>
        </vx-card>
        <vx-card class="mt-1">
          <div class="flex flex-wrap gap-4">
            <div class="w-full md:w-[48%]">
              <h4 class="font-semibold mb-2">Comment</h4>
              <p class="text-sm text-gray-800 leading-relaxed">
                {{ feedbackDetailsCampaingn  && feedbackDetailsCampaingn .comment }}
              </p>
            </div>

            <div class="w-full md:w-[48%] feedback-container">
              <h4 class="font-semibold">Feedback</h4>
              <div class="feedback-box">
                <div class="feedback-rating">
                  <div class="rating-stars">
                    <span
                      v-for="n in 5"
                      :key="n"
                      class="star"
                      :class="{
                        full: n <= Math.floor(rating),
                        half:
                          n === Math.ceil(rating) && !Number.isInteger(rating),
                      }"
                      >★</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card class="mt-1">
          <div class="qna-section">
            <h4 class="my-2 font-semibold">Questions & Answers</h4>

            <vs-collapse accordion>
              <vs-collapse-item v-for="(qa, index) in questions" :key="index">
                <div slot="header" class="qna-question">
                  {{ qa.questionText }}
                </div>
                <div class="qna-answer">
                  {{ qa.answerText }}
                </div>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      rating: 0,
      questions: [],
    };
  },

  computed: {
    ...mapState({
      feedbackDetails: (state) => state.qna.feedbackDetails,
      feedbackDetailsCampaingn: (state) => state.qna.feedbackDetailsCampaingn,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      if (!date) return "-";
      const d = moment(date);
      const formattedDate = d.format(this.formattedDate);
      return formattedDate;
    },
    async getFeedbackDetailsByIdMethod() {
      try {
        await this.$store.dispatch(
          "qna/getFeedbackDetailsByCampaignIdAction",
          {
            id: this.$route.params.ticketId,
            campaignId: this.$route.params.id,
          } 
          // this.$route.params.ticketId,
          // this.$route.params.id
        );
        this.rating = this.feedbackDetailsCampaingn .rating;
        this.questions = this.feedbackDetailsCampaingn .answers;
      } catch (e) {
        // this.$toasted.error(e.message);
      }
    },
  },
  async mounted() {
    await this.getFeedbackDetailsByIdMethod();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
.feedback-container {
  display: flex;
  align-items: center;
}

.feedback-box {
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-wrap: wrap;
}

.feedback-rating {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
}

.rating-score {
  font-size: 1.8rem;
  font-weight: bold;
}

.rating-stars {
  display: flex;
  font-size: 1.2rem;
  margin: 0.2rem 0;
}

.star {
  color: #d1d5db; /* Gray */
}
.star.full {
  color: #fbbf24; /* Amber-400 */
}
.star.half {
  background: linear-gradient(90deg, #fbbf24 50%, #d1d5db 50%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.review-count {
  font-size: 0.85rem;
  color: #6b7280; /* Gray-500 */
}

.feedback-bars {
  flex: 1;
  min-width: 200px;
}

.bar-row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.bar-label {
  width: 1.5rem;
  font-size: 0.85rem;
}

.bar-track {
  flex: 1;
  background: #e5e7eb;
  height: 6px;
  margin: 0 0.5rem;
  border-radius: 4px;
}

.bar-fill {
  background: #111827;
  height: 6px;
  border-radius: 4px;
}

.bar-percentage {
  font-size: 0.75rem;
  color: #6b7280;
  width: 3rem;
  text-align: right;
}

.qna-section {
  margin: 0 auto;
}

.qna-question {
  font-weight: 600;
  font-size: 1rem;
  color: #374151; /* Gray-700 */
}

.qna-answer {
  padding: 0.2rem 0;
  font-size: 0.9rem;
  color: #4b5563; /* Gray-600 */
  line-height: 1;
}
</style>
